module.exports = __webpack_public_path__ + "img/wt-n2live-square.d3ee43d0.png";